import { shape, string } from 'prop-types';

export const geoEntityOption = shape(
    {
        display_name: string,
        state: string,
        label: string,
    },
);
